import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCanvasGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"canvas-grid, design, app-icon, blueprint"} maskId="square-filled-radius-0-stroke-1-IconCanvasGrid"><path fillRule="evenodd" clipRule="evenodd" d="M11.5 6H12.5V3H21V11.5H18V12.5H21V21H12.5V18H11.5V21H3V12.5H6V11.5H3V3H11.5V6ZM11.5 9V11.5H9V12.5H11.5V15H12.5V12.5H15V11.5H12.5V9H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCanvasGrid;
